export default __webpack_public_path__ + "static/media/thirteen.cf0bc49e.svg";